import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function BeforeAfter() {
  const before = ['Ansiedad constante', 'Dependencia emocional', 'Sobrepensar todo', 'Miedo a perder', 'Sentirte insuficiente'];
  const after = ['Control emocional', 'Paz mental', 'Seguridad en vos', 'Decisiones claras', 'Independencia real'];
  return <section className="py-8 md:py-10 px-3 md:px-4 bg-dark" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-17">
          {/* Before */}
          <div className="bg-black border border-rosa/30 rounded-2xl p-6 relative overflow-hidden" data-id="element-18">
            <div className="absolute top-0 left-0 w-full h-1 bg-rosa" data-id="element-19"></div>
            <h3 className="text-2xl font-black text-white mb-6 text-center uppercase tracking-wider" data-id="element-20">
              Antes
            </h3>
            <ul className="space-y-4" data-id="element-21">
              {before.map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-22">
                  <XCircle className="text-rosa shrink-0" size={20} data-id="element-23" />
                  <span className="text-gray-300 font-medium" data-id="element-24">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-black border border-terracota/50 rounded-2xl p-6 relative overflow-hidden shadow-[0_0_20px_rgba(201,123,99,0.15)]" data-id="element-25">
            <div className="absolute top-0 left-0 w-full h-1 bg-terracota" data-id="element-26"></div>
            <h3 className="text-2xl font-black text-white mb-6 text-center uppercase tracking-wider" data-id="element-27">
              Después
            </h3>
            <ul className="space-y-4" data-id="element-28">
              {after.map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-29">
                  <CheckCircle2 className="text-terracota shrink-0" size={20} data-id="element-30" />
                  <span className="text-white font-bold" data-id="element-31">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}